export const getBlogPosts = async (query: string) => {
  const response = await fetch(`api/blogs/posts?${query}`);
  const data = await response.json();
  return data;
};
